import Lottie from "lottie-react";
import LottieIcon from "./ErrorAnimation.json";

const ErrorAnimationComponent = ({ className, message }) => {
  return (
    <div>
      <Lottie
        animationData={LottieIcon}
        loop={true}
        autoplay={true}
        className={`tw-w-72 tw-mt-20  ${className ?? ""} tw-m-auto`}
      />
      <p className="text-danger tw-text-center  tw-font-semibold">{message}</p>
    </div>
  );
};

export default ErrorAnimationComponent;
